import { fetchPost } from "~/utils/fetch";
import { ECode } from "~/_enums/ECode";
import { TAuthSigninRequestsConsumeSuccessData } from "~/_types/TAuthRequestsConsumeSuccessData";

type TInputDto = {
  /**
   * 인증 요청 검증 키
   * default: a9c98c03-858e-4dd6-ae7e-a7d20a5fdf96
   */
  key: string;

  authRequestId: string;
};

type TSuccessOutputDto = {
  code: typeof ECode.Success;
  data: TAuthSigninRequestsConsumeSuccessData;
};

type TErrorMaximumOutputDto = {
  /** 최대 요청 횟수 초과 or 유효시간 초과 or 이미 사용한 토큰 */
  code: typeof ECode.MaxAttempt;
  data: null;
};

type TErrorBadRequestOutputDto = {
  code: typeof ECode.BadRequest;
  data: string;
};

type TOutputDto =
  | TSuccessOutputDto
  | TErrorMaximumOutputDto
  | TErrorBadRequestOutputDto;

export const postAuthSignInRequestsConsume = ({
  authRequestId,
  ...body
}: TInputDto) =>
  fetchPost<TOutputDto>({
    url: `/auth/sign-in/requests/${authRequestId}/consume`,
    body: JSON.stringify(body),
  });
